import { lazy } from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import { CustomerAppLayout } from '@/layouts/CustomerAppLayout';
import LandingPage from '@/pages/LandingPage';
import { PlaceholderPage } from '@/pages/PlaceholderPage';

interface PlaceholderProps {
  title: string;
  description: string;
  testId: string;
}

function placeholder(props: PlaceholderProps) {
  return <PlaceholderPage {...props} />;
}

const QrEntryPage = lazy(() => import('@/pages/QrEntryPage'));
const MenuPage = lazy(() => import('@/pages/MenuPage'));
const CartPage = lazy(() => import('@/pages/CartPage'));
const CheckoutPage = lazy(() => import('@/pages/CheckoutPage'));
const PaymentPage = lazy(() => import('@/pages/PaymentPage'));
const SuccessPage = lazy(() => import('@/pages/OrderSuccessPage'));
const TrackingPage = lazy(() => import('@/pages/TrackingPage'));
const BrowseMenuPage = lazy(() => import('@/pages/BrowseMenuPage'));
const StaticContentPage = lazy(() => import('@/pages/StaticContentPage'));
const MoodsPage = lazy(() => import('@/pages/MoodsPage'));
const StoresPage = lazy(() => import('@/pages/StoresPage'));
const EventDetailPage = lazy(() => import('@/pages/EventDetailPage'));
const SearchPage = lazy(() => import('@/pages/SearchPage'));
const InvalidQrPage = placeholder({
  title: 'Mã QR không hợp lệ',
  description: 'Vui lòng quét lại mã QR tại cửa hàng.',
  testId: 'invalid-qr-page',
});
const StoreClosedPage = placeholder({
  title: 'Cửa hàng đang đóng cửa',
  description: 'Cửa hàng hiện chưa thể nhận đơn mới.',
  testId: 'store-closed-page',
});
const NotFoundPage = placeholder({
  title: 'Không tìm thấy trang',
  description: 'Đường dẫn này không tồn tại.',
  testId: 'not-found-page',
});

export const router: ReturnType<typeof createBrowserRouter> = createBrowserRouter([
  {
    path: '/',
    element: <CustomerAppLayout />,
    children: [
      { index: true, element: <LandingPage /> },
      { path: 'menu', element: <BrowseMenuPage /> },
      { path: 'store/:storeCode/menus', element: <BrowseMenuPage /> },
      { path: 'store/:storeCode/menus/:menuId', element: <BrowseMenuPage /> },
      { path: 'moods', element: <MoodsPage /> },
      { path: 'moods/:moodCode', element: <MoodsPage /> },
      { path: 'stores', element: <StoresPage /> },
      { path: 'search', element: <SearchPage /> },
      { path: 'events/:eventId', element: <EventDetailPage /> },
      { path: 'promotions', element: <Navigate to="/#promotions" replace /> },
      { path: 'about', element: <StaticContentPage kind="about" /> },
      { path: 'franchise', element: <StaticContentPage kind="franchise" /> },
      { path: 'q/:qrToken', element: <QrEntryPage /> },
      { path: 'store/:storeCode/menu', element: <MenuPage /> },
      { path: 'store/:storeCode/menu/:menuId', element: <Navigate to="../menus" replace /> },
      { path: 'cart', element: <CartPage /> },
      { path: 'checkout', element: <CheckoutPage /> },
      { path: 'payment/:orderCode', element: <PaymentPage /> },
      { path: 'order-success/:orderCode', element: <SuccessPage /> },
      { path: 'track/:orderCode', element: <TrackingPage /> },
      { path: 'invalid-qr', element: InvalidQrPage },
      { path: 'store-closed', element: StoreClosedPage },
      { path: '*', element: NotFoundPage },
    ],
  },
]);
